export const INIT = "INIT";

export const init = (
  clientBasePath: string,
  baseURL: string,
  supportedLanguages: string[],
  defaultLanguage: string,
  configs: any
) => ({
  type: INIT,
  payload: {
    clientBasePath,
    baseURL,
    supportedLanguages,
    defaultLanguage,
    externalServices: configs?.externalServices || null,
    license: configs?.license || {},
    appConfig: configs?.appConfig || null,
    moduleConfigFiles: configs?.moduleConfigFiles || null,
    themes: configs.themes,
    themeConfig: configs.themeConfig,
    mapLayersConfig: configs?.mapLayersConfig || null,
    detailLevel: configs?.detailLevel || null
  }
});
